// import React, { useEffect, useState } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import './InterviewConfirmation.css';
// import { INTERVIEWMANAGEMENT_URL } from '../../Services/courseService';

// const InterviewConfirmation = () => {
//   const [statusMessage, setStatusMessage] = useState('');
//   const [loading, setLoading] = useState(true);
//   const userId = localStorage.getItem('userId');
//   const navigate = useNavigate();

//   useEffect(() => {
//     const checkStatus = async () => {
//       try {
//         const response = await axios.get(`${INTERVIEWMANAGEMENT_URL}/v1/interviews/request/status`, {
//           params: { userId }
//         });

//         if (response.data === true) {
//           setStatusMessage(
//             'Your interview request is currently pending. Our admin team is reviewing your request and will schedule the interview soon. You will be notified via email once it is confirmed.'
//           );
//         } else {
//           setStatusMessage(
//             'You have no pending interview requests at the moment. Please submit a request to schedule an interview.'
//           );
//         }
//       } catch (error) {
//         setStatusMessage('Error checking interview status. Please try again later.');
//       } finally {
//         setLoading(false);
//       }
//     };

//     checkStatus();
//   }, [userId]);

//   return (
//     <div className="confirmation-container">
//       <div className="confirmation-box">
//         <h2>Interview Request Status</h2>
//         {loading ? (
//           <p>Checking your interview request status...</p>
//         ) : (
//           <p>{statusMessage}</p>
//         )}
//         <Link to="/" className="back-home-btn">
//           Back to Home
//         </Link>
//       </div>
//     </div>
//   );
// };

// export default InterviewConfirmation;

import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Player } from '@lottiefiles/react-lottie-player';

import './InterviewConfirmation.css';
import { INTERVIEWMANAGEMENT_URL } from '../../Services/courseService';

import pendingAnim from '../../Assets/animations/pendingAnim.json';

const InterviewConfirmation = () => {
  const [statusMessage, setStatusMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [isPending, setIsPending] = useState(false);

  const userId = localStorage.getItem('userId');

  useEffect(() => {
    const checkStatus = async () => {
      try {
        const { data } = await axios.get(
          `${INTERVIEWMANAGEMENT_URL}/v1/interviews/request/status`,
          { params: { userId } }
        );

        if (data === true) {
          setIsPending(true);
          setStatusMessage(
            'Your interview request is currently pending. Our admin team is reviewing your request and will schedule the interview soon. You will be notified via email once it is confirmed.'
          );
        } else {
          setIsPending(false);
          setStatusMessage(
            'You have no pending interview requests at the moment. Please submit a request to schedule an interview.'
          );
        }
      } catch (err) {
        setIsPending(false);
        setStatusMessage('Error checking interview status. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    checkStatus();
  }, [userId]);

  return (
    <div className="confirmation-container">
      <div className="confirmation-box">
        <h2>Interview Request Status</h2>

        {loading ? (
          <div className="conf-body">
            <p>Checking your interview request status...</p>
          </div>
        ) : (
          <div className="conf-body">
            {isPending && (
              <Player
                autoplay
                loop
                src={pendingAnim}
                style={{ height: 150, width: 150 }}
              />
            )}
            <p>{statusMessage}</p>
          </div>
        )}

        <Link to="/" className="back-home-btn">
          Back to Home
        </Link>
      </div>
    </div>
  );
};

export default InterviewConfirmation;
